import { Column } from 'primereact/column'
import { DataTable } from 'primereact/datatable'
import React, { useEffect, useState } from 'react'
import { tableCellCentered } from '../../../../assets/js/styles'
import {
  Btn,
  CustomCheckbox,
  CustomDataTableHeader,
  CustomDropdown,
  CustomMultiSelect,
  CustomPanel,
  DateTime,
  PageHeader,
  Periodo,
  ThreeDots,
} from '../../../../components'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { Fieldset } from 'primereact/fieldset'

import useGestaoCtes, {
  LOAD_MESSAGE,
  mensagemStatus,
  podeCancelarCte,
  podeComplementarCte,
  podeSubstituirCte,
  statusExibicao,
} from './GestaoCtesHook'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import ModalCancelarCte from './ModalCancelarCte'
import BadgeStatusCte from '../../../../components/BadgeStatusCte/BadgeStatusCte'
import ModalEmitirMdfe from './EmitirMdfe/ModalEmitirMdfe'
import ModalEmitirCte from '../RetornoVeiculoApuracao/Cte/ModalEmitirCte'
import ModalEmitirCteSubstituicao from './CteSubstituicao/ModalEmitirCteSubstituicao'

function GestaoCtes({ dispatch, selectedTp, history }) {
  const { state, localDispatch } = useGestaoCtes()
  const [globalFilter, setGlobalFilter] = useState('')

  // Events
  useEffect(() => {
    localDispatch.onInit(selectedTp, state.periodo.dataInicial, state.periodo.dataFinal)
  }, [selectedTp])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break

      case LOAD_MESSAGE.FETCH:
      case LOAD_MESSAGE.FETCH_SUBSTITUICAO:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        break

      case LOAD_MESSAGE.DELETE:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.deleteCte(state.selectedCte)
        break

      case LOAD_MESSAGE.SUCCESS_DELETE:
        dispatch(hideLoadingBox())
        dispatch(showMessageBox(state.loadingMessage, null))
        localDispatch.resetState()
        localDispatch.onInit(selectedTp, state.periodo.dataInicial, state.periodo.dataFinal)
        break

      case LOAD_MESSAGE.EMIT_MDFE:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.emitMdfe(state.modalMdfe.data)
        break

      case LOAD_MESSAGE.SUCCESS_EMIT_MDFE:
        dispatch(hideLoadingBox())
        dispatch(showMessageBox(state.loadingMessage, null))
        localDispatch.onModalMdfeClose()
        localDispatch.resetState()
        break

      case LOAD_MESSAGE.SUCCESS_EMIT_COMPLEMENTAR:
      case LOAD_MESSAGE.SUCCESS_EMIT_SUBSTITUICAO:
        dispatch(hideLoadingBox())
        dispatch(showMessageBox(state.loadingMessage, null))
        localDispatch.resetState()
        localDispatch.onInit(selectedTp, state.periodo.dataInicial, state.periodo.dataFinal)
        break
      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetState()
    }
  }, [state.errorMessage])

  // Helpers

  // Render
  return (
    <>
      <PageHeader>3.18 - Gestão de CTe's</PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel
          showBtnNovo={true}
          onNovo={() => history.push('/main/entregas/emissao-ctes')}
          onVoltar={history.goBack}
        >
          <div className="p-grid">
            <div className="p-col-3">
              <Periodo
                periodoFinal={state.periodo.dataFinal}
                periodoInicial={state.periodo.dataInicial}
                onPesquisar={(pInicial, pFinal) =>
                  localDispatch.onPesquisar(selectedTp, pInicial, pFinal)
                }
              />
            </div>
            <div
              style={{
                display: 'flex',
                marginLeft: '5px',
                gap: '10px',
                paddingTop: 35,
              }}
            >
              <div>
                <Btn
                  onClick={() =>
                    localDispatch.onBtnEmitirMdfeClicked(state.filterdCtes.filter(c => c.selected))
                  }
                >
                  Emitir MDFe
                </Btn>
              </div>
              <div>
                <Btn onClick={() => localDispatch.onClickGerarExcel(state.filterdCtes)}>
                  Exportar Excel
                </Btn>
              </div>
              <div>
                <Btn
                  onClick={() =>
                    localDispatch.onDownloadCte(state.filterdCtes.filter(c => c.selected))
                  }
                >
                  Download CTe
                </Btn>
              </div>
              <div>
                <a href="https://status.focusnfe.com.br/" target="_blank" rel="noopener noreferrer">
                  <Btn>Consultar Status Emissão CTE</Btn>
                </a>
              </div>
            </div>

            <Fieldset legend="Filtro" toggleable collapsed={true} className="p-col-12 p-mt-2">
              <div className="p-grid">
                <div className="p-col-6 p-md-4">
                  <CustomMultiSelect
                    label="Status"
                    value={state.selectedStatus}
                    options={[
                      { label: 'Autorizado', value: 'autorizado' },
                      { label: 'Substituído', value: 'substituido' },
                      { label: 'Cancelado', value: 'cancelado' },
                      { label: 'Erro ao Autorizar', value: 'erro_autorizacao' },
                      { label: 'Processando', value: 'processando_autorizacao' },
                      { label: 'Denegado', value: 'denegado' },
                    ]}
                    onChange={value => localDispatch.handleStatusFiltroChange(value)}
                    optionLabel="label"
                  />
                </div>

                <div className="p-col-6 p-md-4">
                  <CustomMultiSelect
                    label="Cidade"
                    value={state.selectedCidades}
                    options={state.cidadesOptions}
                    onChange={value => localDispatch.handleCidadesFiltroChange(value)}
                    optionLabel="label"
                  />
                </div>

                <div className="p-col-6 p-md-4">
                  <CustomMultiSelect
                    label="Empresa"
                    value={state.selectedEmpresas}
                    options={state.empresasOptions}
                    onChange={value => localDispatch.handleEmpresasFiltroChange(value)}
                    optionLabel="label"
                  />
                </div>

                <div className="p-col-6 p-md-4">
                  <CustomDropdown
                    label="CTe Globalizado"
                    value={state.selectedGlobalizado}
                    options={[
                      { label: 'Todos', value: null },
                      { label: 'Sim', value: true },
                      { label: 'Não', value: false },
                    ]}
                    onChange={value => localDispatch.handleGlobalizadoFiltroChange(value)}
                    optionLabel="label"
                  />
                </div>

                <div className="p-col-6 p-md-4">
                  <CustomDropdown
                    label="Tipo Doc. Referência"
                    value={state.selectedTipoReferencia}
                    options={[{ label: 'Todos', value: null }, ...state.tiposReferenciaOptions]}
                    onChange={value => localDispatch.handleTipoReferenciaFiltroChange(value)}
                    optionLabel="label"
                  />
                </div>

                <div className="p-col-6 p-md-4">
                  <CustomDropdown
                    label="Tipo Documento"
                    value={state.selectedTipoDocumento}
                    options={[{ label: 'Todos', value: null }, ...state.tiposDocumentoOptions]}
                    onChange={value => localDispatch.handleTipoDocumentoFiltroChange(value)}
                    optionLabel="label"
                  />
                </div>

                <div className="p-col-6 p-md-4">
                  <CustomDropdown
                    label="Tipo Serviço"
                    value={state.selectedTipoServico}
                    options={[{ label: 'Todos', value: null }, ...state.tiposServicoOptions]}
                    onChange={value => localDispatch.handleTipoServicoFiltroChange(value)}
                    optionLabel="label"
                  />
                </div>
              </div>
            </Fieldset>

            <div className="p-col-12" style={{ marginTop: 15, marginBottom: 10 }}>
              <CustomCheckbox
                checked={state.selecionarTodos}
                onChange={value => localDispatch.onSelecionarTodosChange(value)}
              >
                Selecionar Todos
              </CustomCheckbox>
            </div>

            <div className="p-grid">
              <div className="p-col-12">
                <DataTable
                  value={state.filterdCtes}
                  paginator={true}
                  rows={10}
                  emptyMessage="Não existem CTe's cadastradas"
                  globalFilter={globalFilter}
                  header={<CustomDataTableHeader onChange={setGlobalFilter} />}
                  sortable
                >
                  <Column
                    header={'#'}
                    body={item => (
                      <CustomCheckbox
                        checked={item.selected}
                        onChange={() => localDispatch.onItemClicked(item)}
                      />
                    )}
                    style={tableCellCentered(60)}
                  />
                  <Column field="ref" header={'Referência'} style={tableCellCentered()} />
                  <Column
                    sortable
                    field="data_emissao"
                    header={'Data Emissão'}
                    style={tableCellCentered(150)}
                    body={item => <DateTime>{item.data_emissao}</DateTime>}
                  />
                  <Column
                    field="status"
                    header={'Status'}
                    body={item => (
                      <div>
                        <div style={{ textAlign: 'center' }}>
                          <BadgeStatusCte status={statusExibicao(item)} />
                        </div>
                        <br />
                        <small>{mensagemStatus(item)}</small>
                      </div>
                    )}
                  />
                  <Column sortable field="client_name" header={'Cliente'} />
                  <Column field="client_city" header={'Cidade'} style={tableCellCentered()} />
                  <Column field="company_name" header={'Empresa'} />
                  <Column
                    field="globalizado"
                    header={'CTe globalizado'}
                    style={tableCellCentered(130)}
                    body={item => (
                      <span style={{ fontWeight: 'bold' }}>{item.globalizado ? 'Sim' : 'Não'}</span>
                    )}
                  />
                  <Column
                    sortable
                    field="tipo_documento_descricao"
                    header={'Tipo Documento'}
                    style={tableCellCentered(140)}
                    body={item => <span style={{ fontWeight: 'bold' }}>{item.tipo_documento_descricao}</span>}
                  />
                  <Column
                    sortable
                    field="tipo_servico_descricao"
                    header={'Tipo Serviço'}
                    style={tableCellCentered(130)}
                  />
                  <Column sortable field="numero" header={'Número CTe'} style={tableCellCentered()} />
                  <Column
                    sortable
                    field="documento_referencia_tipo"
                    header={'Tipo Doc. Referência'}
                    style={tableCellCentered(130)}
                  />
                  <Column
                    sortable
                    field="documento_referencia"
                    header={'Doc. Referência'}
                    style={tableCellCentered()}
                  />
                  <Column
                    header="Menu"
                    style={tableCellCentered(70)}
                    body={cte => {
                      const menuItems = []
                      if (cte.caminho_dacte) menuItems.push('DACTE')
                      if (cte.caminho_xml) menuItems.push('XML')
                      if (cte.caminho_xml_cancelamento) menuItems.push('XML Cancelamento')
                      if (podeCancelarCte(cte)) menuItems.push('Cancelar CTe')
                      if (podeComplementarCte(cte)) menuItems.push('CTe Complementar')
                      if (podeSubstituirCte(cte)) menuItems.push('CTe de Substituição')

                      return menuItems.length > 0 ? (
                        <ThreeDots
                          items={menuItems}
                          onClick={item => localDispatch.onMenuItemClick(item, cte)}
                        />
                      ) : null
                    }}
                    bodyStyle={tableCellCentered()}
                  />
                </DataTable>
              </div>
            </div>
          </div>
        </CustomPanel>
      </div>
      <ModalCancelarCte
        isVisible={state.modal.visible}
        cte={state.modal.cte}
        onCancel={localDispatch.onModalDeleteClose}
        onSave={localDispatch.onModalDeleteSave}
        onError={localDispatch.onModalError}
      />
      <ModalEmitirCte
        selectedTp={selectedTp}
        visible={state.modalComplementar.visible}
        cteComplementado={state.modalComplementar.cte}
        onModalClose={localDispatch.onModalComplementarClose}
        onModalSave={localDispatch.onModalComplementarSave}
        onError={localDispatch.onModalError}
      />
      <ModalEmitirCteSubstituicao
        visible={state.modalSubstituicao.visible}
        cte={state.modalSubstituicao.cte}
        dados={state.modalSubstituicao.dados}
        onModalClose={localDispatch.onModalSubstituicaoClose}
        onModalSave={localDispatch.onModalSubstituicaoSave}
        onError={localDispatch.onModalError}
      />
      <ModalEmitirMdfe
        isVisible={state.modalMdfe.visible}
        ctes={state.modalMdfe.ctes}
        onClose={localDispatch.onModalMdfeClose}
        onSave={localDispatch.onModalMdfeSave}
        onError={localDispatch.onModalError}
        selectedTp={selectedTp}
      />
    </>
  )
}
const mapToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapToProps)(withRouter(GestaoCtes))
